import { AppState } from '../../root-reducer';

export const selectActiveAllMap = (state: AppState) => state.superMapDomain.activeTileLayer;
export const selectActiveAllMapIsFetching = (state: AppState) => state.superMapDomain.activeTileLayerFetching;
export const selectActiveAllMapIsLoading = (state: AppState) => state.superMapDomain.activeTileLayerLoading;
